if (!customElements.get('new-quiz')) {
  customElements.define(
    'new-quiz',
    class NewQuiz extends HTMLElement {
      constructor() {
        super();

        this.cards = this.querySelectorAll('.quiz-card');
        this.backButtons = this.querySelectorAll('.quiz-back');
        this.resetButtons = this.querySelectorAll('.quiz-reset');
        this.modalContent = this.closest('.new-quiz-modal-content');

        this.applyDepthIndex();
        
        this.cards.forEach(card => {
            card.addEventListener('click', this.showChild.bind(this))
        })

        this.backButtons.forEach(button => {
            button.addEventListener('click', this.quizBack.bind(this))
        })

        this.resetButtons.forEach(button => {
            button.addEventListener('click', this.resetQuiz.bind(this))
        })
      }

      showChild(event) {
        const target = event.target;
        const emptyCard = target.nextElementSibling?.querySelector('ul')?.children.length == 0;

        if(target.hasAttribute('href') || emptyCard) return;

        this.modalContent.classList.add('quiz-running');

        target.closest('ul').classList.add('active');
        target.closest('li').classList.add('active');
        target.closest('.quiz-child')?.classList.add('hide-heading');
      }

      resetQuiz(event) {
        const target = event.target;

        this.modalContent.classList.remove('quiz-running');

        this.querySelectorAll('ul').forEach(item => item.classList.remove('active'));
        this.querySelectorAll('li').forEach(item => item.classList.remove('active'));
        this.querySelectorAll('.quiz-child').forEach(item => item.classList.remove('hide-heading'));
      }

      quizBack(event) {
        const target = event.target;
        const targetLi = target.closest('li');

        targetLi.closest('.quiz-child')?.classList.remove('hide-heading');
        targetLi.closest('ul').classList.remove('active');
        targetLi.classList.remove('active');

        if(targetLi.getAttribute('data-level') == '1') {
          this.modalContent.classList.remove('quiz-running');  
        }
      }

      applyDepthIndex() {
        const setDepthIndex = (ul, depth = 1) => {
          const children = ul.querySelectorAll(':scope > li');

          children.forEach(li => {
            li.setAttribute('data-level', depth);

            const nestedUl = li.querySelector(':scope > ul');
            if (nestedUl) {
              setDepthIndex(nestedUl, depth + 1);
            }
          });
        };

        this.querySelectorAll('ul').forEach(ul => {
          if (!ul.closest('li')) {
            setDepthIndex(ul, 1);
          }
        });
      }
    }
  );
}
